//
// VisualController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./PositionedModelController";
import "../../models/view/layout/Visual";
import "../visualElements/VisualElementController";
import "./HudController";
import "./ContainerController";

var VisualController = createModule("BIRD::VisualController", ["BIRD::BIRDModelController","BIRD::PositionedModelController"], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        getFooterHeight: [5],
        getModel: [1],
        getVisualElementPadding: [4],
        setFooterHeight: [0,5],
        handleAccessibilityClick: [2],
        getCompositeParent: [1],
        disableAccessibilityForView: [0],
        getVisualElementController: [1],
        getHudController: [1],
        enableAccessibilityForView: [0],
    },
    {
        _create: [4,1,1],
    },
    ,
]);
export default VisualController;
